import { Component, ViewChild } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { ConfirmPopup } from 'primeng/confirmpopup';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Info, InfoItem } from '../../../../shared/interface';

@Component({
  selector: 'app-modifica-info-backoffice',
  templateUrl: './modifica-info-backoffice.component.html',
  styleUrl: './modifica-info-backoffice.component.css'
})
export class ModificaInfoBackofficeComponent {

  constructor(private apiService: ApiService, private router: Router, private route: ActivatedRoute, private confirmationService: ConfirmationService) { }

  @ViewChild(ConfirmPopup) confirmPopup!: ConfirmPopup;
  
  formInfo!: FormGroup;

  info?: Info;

  ngOnInit(): void {

    this.formInfo = new FormGroup({})

    this.route.params.subscribe(params => {
      const id = params['id'];

      this.apiService.getInfo(id).subscribe({
        next: (data) => this.info = data,
        error: (err) => this.router.navigate(['/backoffice/info']),
        complete: () => {

          this.info?.items.map((contenuto: InfoItem) => {
            this.formInfo.addControl('titolo_' + contenuto.id, new FormControl(null, Validators.required))
            this.formInfo.addControl('descrizione_' + contenuto.id, new FormControl(null))

            this.formInfo.patchValue({
              ['titolo_' + contenuto.id]: contenuto.titolo,
              ['descrizione_' + contenuto.id]: contenuto.descrizione
            })
          })

        }
      })

    })

  }

  onAddItem() {

    this.info?.items.push({
      id: this.info?.items!.length + 1,
      id_info: this.info!.id,
      titolo: '',
      descrizione: '',
      new: true,
      data_creazione: new Date(),
      data_aggiornamento: new Date()
    })

    this.info?.items.map((contenuto, index) => {
      this.formInfo.addControl('titolo_' + contenuto.id, new FormControl(null, Validators.required))
      this.formInfo.addControl('descrizione_' + contenuto.id, new FormControl(null))
    })

  }

  onRemoveItem(id: number) {
    this.info!.items = this.info?.items.filter(item => item.id != id) || [];
    
    this.formInfo.removeControl('titolo_' + id)
    this.formInfo.removeControl('descrizione_' + id)
  }

  onDeletePopup(event: Event) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: "Sei sicuro di voler eliminare la info?",
      reject: () => this.confirmationService.close(),
      accept: () => {
        this.apiService.deleteInfo(this.info!.id).subscribe({
          next: (data) => this.apiService.setDefinizioni(),
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {
            this.confirmationService.close()
            this.router.navigate(['/backoffice/info']);
            this.apiService.message("success", "Eliminazione", "La info è stata eliminata con successo")
          }
        })
      }
    });
  }

  onDelete() {
    this.confirmPopup.accept();
  }

  onAnnulla() {
    this.confirmPopup.reject();
  }

  onSubmit() {

    let info: any = { items: [] }

    this.info?.items.map((item, index) => {
      info.items.push({ 
        id: item.id, titolo: this.formInfo.get('titolo_' + item.id)?.value || '', 
        descrizione: this.formInfo.get('descrizione_' + item.id)?.value || '', 
        new: item.new || false})
    })
    
    this.apiService.updateInfo(info, this.info!.id).subscribe({
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {
        this.apiService.setInfos();
        this.apiService.message('success', 'Successo', 'La info è stata modificata con successo!');
        this.router.navigate(['/backoffice/info'])
      }
    })

  }


}
